var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside-tools"},[_c('div',{staticClass:"aside-tools-label"},[_vm._t("logo")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }